import {list} from "custom/demo/requests/admin/validation-studies";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {edit: true, list, new: true};

const columns = [
  {key: "external_id", label: "External ID"},
  {key: "name", label: "Name"},
  {key: "style", label: "Style"},
  {key: "subjects_total", label: "Subjects - Total"},
  {key: "subjects_completed", label: "Subjects - Completed"},
  {key: "subjects_retest_completed", label: "Subjects - Retest Completed"},
  {key: "survey_names", label: "Surveys"},
  {key: "retest_survey_names", label: "Retest Surveys"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Study" path="/admin/validation/studies" plural="Studies" />;
}
